import { ErrorHandler, NgModule } from '@angular/core';
import { InstanaErrorHandler } from './services/instana-error.handler';
import { InstanaScriptLoaderService } from './services/instana-script-loader.service';
import { InstanaConfigService } from './bootstrappers/instana-config.service';
import { InstanaTrackingService } from './bootstrappers/instana-tracking.service';

@NgModule({
  providers: [
    {
      provide: ErrorHandler,
      useClass: InstanaErrorHandler,
    },
    InstanaErrorHandler,
    InstanaScriptLoaderService,
    InstanaConfigService,
    InstanaTrackingService,
  ],
})
export class TswpCoreCommonDiagInstanaModule { }
